@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/size";

web-top-brand {

    --top-brand-height: #{size.$xxxl};
    --top-brand-max-height: #{size.$xxxl};

    .brand {
        display: flex;
        gap: 0.6rem;
        margin: 1rem 0 1rem 0.6rem;
        height: var(--top-brand-height);
        max-height: var(--top-brand-max-height);

        &.collectivity {
            gap: 0;

            @media (max-width: 575px) {
                flex-direction: column;
            }
        }

        @media (max-width: breakpoints.$screen-sm-max) {
            img {
                width: 11rem;
            }
        }

        @media (min-width: breakpoints.$screen-lg-min) {
            margin-left: unset;
        }

        .logo,
        .slogan {
            height: 100%;
            width: auto;
        }
        .slogan {
            display: none;

            @media (min-width: breakpoints.$screen-lg-min) {
                display: block;
            }
        }
    }
}
